/* Product page redesign, 11 Oct 2026. Variant picker, gallery, AJAX add to cart,
   tabs/accordions, recommendations, sticky bar, size guide and lightbox. */
(function () {
  var root = document.querySelector('[data-tpd]');
  if (!root) return;
  var $ = function (s, el) { return (el || document).querySelector(s); };
  var $$ = function (s, el) { return [].slice.call((el || document).querySelectorAll(s)); };
  var desk = window.matchMedia('(min-width: 990px)');

  /* ---------------- gallery ---------------- */
  var track = $('[data-tpd-track]');
  var slides = track ? $$('.tpd-slide', track) : [];
  var thumbs = $$('.tpd-thumb');
  var dots = $$('.tpd-dot');
  var counter = $('[data-tpd-count]');
  var cur = 0;

  function mark(i) {
    cur = i;
    thumbs.forEach(function (t) { t.classList.toggle('is-on', +t.dataset.i === i); });
    dots.forEach(function (d) { d.classList.toggle('is-on', +d.dataset.i === i); });
    if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
  }
  function go(i, smooth) {
    var s = slides[i];
    if (!s || !track) return;
    /* RTL-safe: scroll the track by the slide's offset relative to the track. */
    var delta = s.getBoundingClientRect().left - track.getBoundingClientRect().left;
    track.scrollTo({ left: track.scrollLeft + delta, behavior: 'auto' });  /* instant: smooth scroll stalls with mandatory snap in some browsers */
    mark(i);
  }
  if (track && slides.length > 1 && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting && e.intersectionRatio > 0.6) mark(slides.indexOf(e.target)); });
    }, { root: track, threshold: [0.6] });
    slides.forEach(function (s) { io.observe(s); });
  }
  thumbs.concat(dots).forEach(function (b) { b.addEventListener('click', function () { go(+b.dataset.i); }); });
  if (track) {
    var st = +track.dataset.start || 0;
    if (st) requestAnimationFrame(function () { go(st, false); });
  }
  function slideIndexById(id) {
    for (var i = 0; i < slides.length; i++) if (String(slides[i].dataset.id) === String(id)) return i;
    return -1;
  }

  /* lightbox */
  var lb = $('[data-tpd-lb]'), lbImg = $('[data-tpd-lb-img]');
  var zoom = $('[data-tpd-zoom]');
  function openLb() {
    var s = slides[cur]; if (!s || !lb) return;
    lbImg.src = s.dataset.full; lbImg.alt = (s.querySelector('img') || {}).alt || '';
    lb.hidden = false; document.documentElement.style.overflow = 'hidden';
    $('[data-tpd-lb-x]').focus();
  }
  function closeLb() { if (!lb || lb.hidden) return; lb.hidden = true; document.documentElement.style.overflow = ''; if (zoom) zoom.focus(); }
  if (zoom) zoom.addEventListener('click', openLb);
  if (lb) lb.addEventListener('click', closeLb);
  slides.forEach(function (s) { s.addEventListener('click', function () { if (desk.matches) openLb(); }); });

  /* ---------------- variants ---------------- */
  var variants = [];
  try { variants = JSON.parse(($('[data-tpd-variants]') || {}).textContent || '[]'); } catch (e) {}
  var inputs = $$('[data-tpd-input]');
  var idIn = $('[data-tpd-id]');
  var atc = $('[data-tpd-atc]');
  var sBtn = $('[data-tpd-sticky-btn]');
  var optCount = 0;
  inputs.forEach(function (i) { optCount = Math.max(optCount, +i.dataset.tpdInput + 1); });
  var current = null;

  function chosen() {
    var out = [];
    for (var i = 0; i < optCount; i++) {
      var hit = $('[data-tpd-input="' + i + '"]:checked');
      out.push(hit ? hit.value : null);
    }
    return out;
  }
  function match(sel) {
    for (var i = 0; i < variants.length; i++) {
      var ok = true;
      for (var j = 0; j < sel.length; j++) if (sel[j] !== null && variants[i].opts[j] !== sel[j]) { ok = false; break; }
      if (ok) return variants[i];
    }
    return null;
  }
  function markStock(sel) {
    inputs.forEach(function (inp) {
      var oi = +inp.dataset.tpdInput, probe = sel.slice();
      probe[oi] = inp.value;
      var any = variants.some(function (vr) {
        if (!vr.ok) return false;
        for (var j = 0; j < probe.length; j++) if (j !== oi && probe[j] !== null && vr.opts[j] !== probe[j]) return false;
        return vr.opts[oi] === inp.value;
      });
      var l = inp.closest('label');
      if (l) { l.classList.toggle('is-out', !any); l.classList.toggle('is-sel', inp.checked); }
      if (l && l.classList.contains('tpd-sw')) l.setAttribute('aria-checked', inp.checked ? 'true' : 'false');
    });
  }
  function setBtn(b, ok, label) { if (!b) return; b.disabled = !ok; b.textContent = label; }
  function text(sel, t) { var e = $(sel); if (e) e.textContent = t; }

  function apply(initial) {
    var sel = chosen();
    markStock(sel);
    for (var i = 0; i < optCount; i++) { if (sel[i]) text('[data-tpd-optval="' + i + '"]', sel[i]); }
    var vr = match(sel);
    if (!vr) { setBtn(atc, false, 'הצירוף הזה אינו זמין'); setBtn(sBtn, false, 'לא זמין'); return; }
    current = vr;
    idIn.value = vr.id;
    text('[data-tpd-price]', vr.price);
    text('[data-tpd-sticky-price]', vr.price);
    text('[data-tpd-inst]', vr.inst);
    var cmp = $('[data-tpd-cmp]');
    if (cmp) { if (vr.cmp) { cmp.textContent = vr.cmp; cmp.hidden = false; } else cmp.hidden = true; }
    var stock = $('[data-tpd-stock]');
    if (stock) stock.classList.toggle('is-out', !vr.ok);
    text('[data-tpd-stock-t]', vr.ok ? 'במלאי · מגיע תוך 3–5 ימי עסקים' : 'אזל מהמלאי');
    setBtn(atc, vr.ok, vr.ok ? 'הוספה לסל' : 'אזל מהמלאי');
    setBtn(sBtn, vr.ok, vr.ok ? 'הוספה לסל' : 'אזל מהמלאי');
    var so = $('[data-tpd-sticky-opt]'); if (so && vr.title && vr.title !== 'Default Title') so.textContent = ' · ' + vr.title;
    var si = $('[data-tpd-sticky-img]'); if (si && vr.thumb) si.src = vr.thumb;
    if (!initial) {
      if (vr.imgId) { var k = slideIndexById(vr.imgId); if (k > -1) go(k); }
      if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', vr.id); history.replaceState({}, '', u); }
    }
  }
  inputs.forEach(function (inp) { inp.addEventListener('change', function () { apply(false); }); });
  if (variants.length) apply(true);

  /* ---------------- quantity ---------------- */
  var qIn = $('[data-tpd-qty-in]');
  $$('[data-tpd-qty]').forEach(function (b) {
    b.addEventListener('click', function () {
      var n = Math.min(10, Math.max(1, (parseInt(qIn.value, 10) || 1) + (+b.dataset.tpdQty)));
      qIn.value = n;
    });
  });
  if (qIn) qIn.addEventListener('change', function () { qIn.value = Math.min(10, Math.max(1, parseInt(qIn.value, 10) || 1)); });

  /* ---------------- add to cart (AJAX, falls back to the normal form post) ---------------- */
  var form = $('#tpd-form');
  var err = $('[data-tpd-err]');
  var busy = false;
  function bumpCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      $$('[data-tz-count]').forEach(function (el) { el.textContent = c.item_count; el.hidden = c.item_count === 0; });
    }).catch(function () {});
  }
  function add() {
    if (busy || !form) return;
    if (!window.fetch) { form.submit(); return; }
    busy = true; if (err) err.hidden = true;
    var fd = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        busy = false;
        if (!res.ok) { if (err) { err.textContent = res.j.description || res.j.message || 'לא הצלחנו להוסיף לסל. נסי שוב.'; err.hidden = false; } return; }
        bumpCount();
        [atc, sBtn].forEach(function (b) { if (b) b.textContent = b === sBtn ? 'נוסף ✓' : 'נוסף לסל ✓'; });
        setTimeout(function () { if (current) { setBtn(atc, current.ok, current.ok ? 'הוספה לסל' : 'אזל מהמלאי'); setBtn(sBtn, current.ok, current.ok ? 'הוספה לסל' : 'אזל מהמלאי'); } }, 2200);
      })
      .catch(function () { busy = false; form.submit(); });
  }
  if (form) form.addEventListener('submit', function (e) { e.preventDefault(); add(); });
  if (sBtn) sBtn.addEventListener('click', add);

  /* ---------------- tabs (desktop) / accordions (mobile) ---------------- */
  var tabs = $$('.tpd-tablist [role=tab]');
  var pws = $$('.tpd-pw');
  function showTab(id, focus) {
    tabs.forEach(function (t) {
      var on = t.dataset.t === id;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      if (on && focus) t.focus();
    });
    pws.forEach(function (p) {
      var on = p.dataset.p === id;
      p.classList.toggle('is-open', on);
      var b = p.querySelector('.tpd-acc'); if (b) b.setAttribute('aria-expanded', on ? 'true' : 'false');
    });
  }
  tabs.forEach(function (t, i) {
    t.addEventListener('click', function () { showTab(t.dataset.t); });
    t.addEventListener('keydown', function (e) {
      var k = e.key, n = null;
      if (k === 'ArrowLeft') n = tabs[(i + 1) % tabs.length];       /* RTL: left = next */
      else if (k === 'ArrowRight') n = tabs[(i - 1 + tabs.length) % tabs.length];
      else if (k === 'Home') n = tabs[0]; else if (k === 'End') n = tabs[tabs.length - 1];
      if (n) { e.preventDefault(); showTab(n.dataset.t, true); }
    });
  });
  $$('.tpd-acc').forEach(function (b) {
    b.addEventListener('click', function () {
      var p = b.closest('.tpd-pw'), open = !p.classList.contains('is-open');
      p.classList.toggle('is-open', open);
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
  /* going back to desktop: exactly one panel open, matching the selected tab */
  desk.addEventListener && desk.addEventListener('change', function (e) {
    if (!e.matches) return;
    var sel = tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0];
    showTab(sel ? sel.dataset.t : 'desc');
  });

  /* ---------------- recommendations ---------------- */
  var rel = $('[data-tpd-rel]');
  if (rel && rel.dataset.url && window.fetch) {
    fetch(rel.dataset.url).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
      if (!html) return;
      var box = document.createElement('div'); box.innerHTML = html;
      var out = box.querySelector('[data-tpd-recs-out]');
      if (out && +out.dataset.n >= 2) { $('[data-tpd-rel-row]', rel).innerHTML = out.innerHTML; rel.hidden = false; }
    }).catch(function () {});
  }

  /* ---------------- sticky bar (phones) ---------------- */
  var bar = $('[data-tpd-sticky]');
  var foot = document.querySelector('footer');
  if (bar && atc && 'IntersectionObserver' in window) {
    var atcGone = false, footIn = false;
    var paint = function () { bar.hidden = desk.matches || !atcGone || footIn; };
    new IntersectionObserver(function (es) { var e = es[0]; atcGone = !e.isIntersecting && e.boundingClientRect.top < 0; paint(); }).observe(atc);
    if (foot) new IntersectionObserver(function (es) { footIn = es[0].isIntersecting; paint(); }).observe(foot);
    desk.addEventListener && desk.addEventListener('change', paint);
  }

  /* ---------------- size guide ---------------- */
  var sg = $('[data-tpd-sg]'), sgBtn = $('[data-tpd-guide]');
  if (sg && sgBtn && sgBtn.tagName === 'BUTTON') {
    sgBtn.addEventListener('click', function () { sg.hidden = false; });
    $$('[data-tpd-sg-close]', sg).forEach(function (c) { c.addEventListener('click', function () { sg.hidden = true; }); });
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { if (sg) sg.hidden = true; closeLb(); } });
})();
